import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import { ZipCity } from '@chancenwerk/db/adresse.js';
import { html } from 'lit';

@Entity()
export class ZipCityAspect extends AbstractAspect {
  static override _class = 'ZipCityAspect';

  @Field(type => ZipCity) zipCity: Maybe<ZipCity>;

  constructor(doc: PartialEntityData<ZipCityAspect>) {
    super(doc);
  }

  override getMongoFilter(): object | null {
    if (!this.fieldName || !this.zipCity) return null;

    if (this.zipCity.zip && this.zipCity.city)
      return {
        [this.fieldName + '.' + 'city']: this.zipCity.city,
        [this.fieldName + '.' + 'zip']: this.zipCity.zip,
      };

    if (this.zipCity.zip)
      return {
        [this.fieldName + '.' + 'zip']: this.zipCity.zip,
      };

    if (this.zipCity.city)
      return {
        [this.fieldName + '.' + 'city']: this.zipCity.city,
      };

    return null;
  }
}

export const ZipCityAspectSchema: AspectConfig<ZipCityAspect> = {
  aspectConstructor: ZipCityAspect,
  renderEditor: ({ aspectValue }) => html`
    <chancen-component-zip-city-picker
      clearable
      .value=${aspectValue.zipCity}
      @value-picked=${(e: ValueEvent<Maybe<ZipCity>>) => {
        aspectValue.zipCity = e.detail.value ?? null;
      }}
    ></chancen-component-zip-city-picker>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.zipCity ? html` ${aspectValue.zipCity.toString()} ` : null),
};
